import { Main } from 'components/Main';
import * as React from 'react';
export const ContentWrapper = ({ sidebar, className, children }) => (React.createElement(Main, { sidebar: sidebar },
    React.createElement("div", { className: "container" },
        React.createElement("div", { className: `col-lg-12 no-pad ${className}` }, children))));
